module.exports = __webpack_public_path__ + "static/media/monkey--big.4a17c84d.png";